var chunkMapping = {
	"1237": [
		91237
	],
	"1501": [
		51501
	],
	"2028": [
		92028
	],
	"2369": [
		52369
	],
	"2399": [
		32399
	],
	"5207": [
		65207
	],
	"6333": [
		6333
	],
	"7523": [
		27523
	],
	"7629": [
		17629
	],
	"7701": [
		87701
	],
	"9759": [
		89759
	]
};
var idToExternalAndNameMapping = {
	"6333": [
		"default",
		"./PartnerApp",
		88924
	],
	"17629": [
		"default",
		"./PricingApp",
		14685
	],
	"27523": [
		"default",
		"./DocGenApp",
		17283
	],
	"32399": [
		"default",
		"./PricingOption",
		14685
	],
	"51501": [
		"default",
		"./UnderWrittingApp",
		72529
	],
	"52369": [
		"default",
		"./Document",
		17283
	],
	"65207": [
		"default",
		"./IndustryApp",
		86849
	],
	"87701": [
		"default",
		"./ReportingApp",
		74133
	],
	"89759": [
		"default",
		"./SalesQueue",
		17283
	],
	"91237": [
		"default",
		"./ReviewInformationApp",
		45391
	],
	"92028": [
		"default",
		"./ltovfUiEmp",
		9960
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}